module.exports = __webpack_public_path__ + "static/img/467583ea1cf1e5183cb7a600d5919e5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro5.jpg
// module id = y2lc
// module chunks = 1